import React from "react";
import { classNames } from "../../utils";

const Label = ({ className, ...props }) => {
  return <label className={classNames(className, "label")} {...props} />;
};

export default Label;
